/**
 * 日期解析公共工具
 *
 * 背景：后端 @JsonFormat 输出 "yyyy-MM-dd HH:mm:ss"（空格分隔、无时区）。
 * iOS JavaScriptCore / 部分 Android WebView 对 `new Date("2026-08-01 15:19:35")`
 * 返回 Invalid Date（只完整支持 ISO 8601 "yyyy-MM-ddTHH:mm:ss"），
 * 导致时间比较错乱（如预约记录页按钮显示错误）。
 *
 * 统一用正则显式按本地时区构造 Date，绕开浏览器解析差异。
 */

/**
 * 安全解析本地时间字符串为 Date 对象
 * 兼容：24小时制 "2026-08-01 15:19:35" / ISO "2026-08-01T15:19:35"
 *       12小时制 "2026-08-01 04:00:35 PM" / "2026-08-01 下午4:00:35"
 * @param {string} str 时间字符串
 * @returns {Date|null} 解析失败或空值返回 null
 */
export function parseLocalDateTime(str) {
    if (!str) return null;
    const s = String(str).trim();
    // 24-hour: 2026-08-01 15:19:35 / 2026-08-01T15:19:35
    let m = s.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{1,2}):(\d{2})(?::(\d{2}))?$/);
    if (m) {
        return new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +(m[6] || 0));
    }
    // 12-hour: 2026-08-01 04:00:35 PM / 2026-08-01 下午4:00:35
    m = s.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{1,2}):(\d{2})(?::(\d{2}))?\s*(AM|PM|am|pm|上午|下午)?$/);
    if (m) {
        let h = parseInt(m[4], 10);
        const ap = (m[7] || '').toLowerCase();
        if (ap === 'pm' || ap === '下午') {
            if (h < 12) h += 12;
        } else if (ap === 'am' || ap === '上午') {
            if (h === 12) h = 0;
        }
        return new Date(+m[1], +m[2] - 1, +m[3], h, +m[5], +(m[6] || 0));
    }
    // 兜底：交给浏览器解析（FE 日期选择器输出格式）
    const d = new Date(s);
    return isNaN(d.getTime()) ? null : d;
}
